module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverwrapper animated-background"
  }, [(_vm.livre) ? [(_vm.livre.couverture) ? _c('img', {
    attrs: {
      "src": _vm.livre.couverture
    }
  }) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.titre.titre, 50)))]), _c('h6', {
    staticClass: "auteurs"
  }, [_vm._v(_vm._s(_vm.auteurs))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f83c886c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search-item-book.vue
// module id = 1370
// module chunks = 1